import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { get, post } from "../../../Services/ApiHandler";
import Loader from "../../../components/Loader";
import { checkPermission } from "../../redux/api/PermissionManager";

const Commission = () => {
  const navigate = useNavigate();

  const [errors, setErrors] = useState(false);
  const [list, setList] = useState(null);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetch = async () => {
    setLoading(true);
    try {
      const res = await get(`${URLS.MASTERURL}?type=${12}`);
      toast.success(res?.message);
      console.log("res commission list", res?.data[0]);
      setList(res?.data[0]);
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const handleSubmit = async () => {
    if (!edit) {
      // toggle edit mode
      setEdit(true);
      return;
    }

    if (!list?.name) {
      setErrors(true);
      return;
    }

    setErrors(false);
    setLoading(true);

    try {
      const formdata = new FormData();
      formdata.append("type", 12);
      formdata.append("name", list.name);

      const res = await post(`${URLS.MASTERURL}${list.id}/edit/`, formdata);
      console.log("res edit commission", res);
      toast.success("Edited successfully");

      setEdit(false);
      fetch(); // refresh data
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Topbar header={"Master"} subHead={"Commission"} />

      <div className="d-flex ae-js gap-4">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Special date commission percentage
          </p>
          <input
            className="input-box"
            name="commission"
            readOnly={!edit}
            value={list?.name || ""}
            onChange={(e) => {
              const value = e.target.value;
              if (value <= 100) {
                setList({ ...list, name: value });
              }
            }}
            type="number"
            placeholder="Commission %"
            min="0"
            max="100"
          />

          {errors && <p className="err">Percentage cannot be Empty</p>}
        </div>
        <span style={{ marginBottom: 10 }}>%</span>
        {checkPermission("CAN-EDIT-COMMISSION") && (
          <button
            onClick={handleSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
            style={{ minWidth: "100px" }}
          >
            {edit ? "Submit" : "Edit"}
          </button>
        )}
      </div>

      {loading && <Loader />}
    </div>
  );
};

export default Commission;
